<template>
  <a-modal title="Cargar Candidatos"
           :visible="visible"
           width="90%"
           @ok="close"
           @cancel="close"
           style="top: 20px;">
    <a-upload-dragger name="file" :beforeUpload="beforeUpload" :fileList="fileList">
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox"/>
      </p>
      <p class="ant-upload-text">Clic o arrastrar y soltar en esta área para subir un archivo</p>
      <p class="ant-upload-hint">
        Solo es permitido seleccionar un archivo
      </p>
    </a-upload-dragger>
    <a-alert
      message="Proceso terminado correctamente."
      :description="mensajes.ok"
      type="success"
      show-icon
      v-if="mensajes.okVisible"
    />
    <a-alert
      message="Error"
      type="error"
      show-icon
      closeText="X"
      v-if="mensajes.errorVisible"
      :afterClose="()=>{mensajes.errorVisible = false}">
      <template slot="description">
        {{mensajes.error}}
      </template>
    </a-alert>
    <a-button :loading="loading"
                    style="background-color: rgb(29, 111, 66); color: white;margin-top:5px;"
                    icon="file-excel" @click="descargarPlantilla()">
      Plantilla
    </a-button>
  </a-modal>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['visible', 'idRequisicion'],
    data () {
      return {
        fileList: [],
        mensajes: {
          errorVisible: false,
          error: '',
          okVisible: false,
          ok: ''
        },
        loading: false
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.httpClientUploader = this.httpClient.getNewInstance()
      this.httpClientUploader.defaults.headers['Content-Type'] = 'multipart/form-data'
    },
    methods: {
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.uploadFile(file)
        }
        return false
      },
      validateFile (file) {
        console.log(file.type)
        const isValidType = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        if (!isValidType) {
          this.$message.error('Solo se pemiten archivos de excel 2007 o superiores. (Formato XLSX)')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }

        return true
      },
      uploadFile (file) {
        let self = this
        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea cargar este archivo?',
          onOk () {
            return new Promise((resolve, reject) => {
              self.mensajes.okVisible = false
              self.mensajes.ok = ''
              self.mensajes.errorVisible = false
              self.mensajes.error = ''
              let request = new FormData()
              request.append('documento', file)

              self.httpClientUploader.post('gestion_humana/persona_requisiciones/cargar/' + self.idRequisicion, request)
                .then((response) => {
                  self.mensajes.ok = response.data.message
                  self.mensajes.okVisible = true
                })
                .catch((error) => {
                  self.mensajes.error = error.response.data.message
                  self.mensajes.errorVisible = true
                })
                .then(() => {
                  self.$emit('isreloadData', true)
                  resolve()
                })
            })
          },
          onCancel () {}
        })
      },
      close () {
        this.$emit('ok')
      },
      descargarPlantilla () {
        this.loading = true
        this.httpClient.getInstance().get('template_req/download', {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Requisiciones/CargarCandidatos.vue